import * as React from 'react';

import { IOption } from 'src/components/Form/Select';
import { Select, FormSelect } from 'src/components';
import { IAllItemOptions } from '../Parameters/types';

interface IItemSelectorState {
  selectedParameter?: IOption<any> | null;
  itemOptions: Array<IOption<any>>;
  noItemsForParameter: boolean;
}
interface IItemSelectorProps extends IAllItemOptions {
  parameterOptions: Array<IOption<any>>;
  name: string;
  disabled: boolean;
  selectedItemId: number;
}

class ItemSelector extends React.Component<
  IItemSelectorProps,
  IItemSelectorState
> {
  placeholderValue = {
    label: 'Filter by parameter',
    value: '',
  };
  noItemValue = {
    label: '—',
    value: '',
  };
  state: IItemSelectorState = {
    selectedParameter: null,
    itemOptions: [this.noItemValue],
    noItemsForParameter: false,
  };

  componentDidMount() {
    this.fillInitialParameter();
    this.updateItemOptions();
  }

  fillInitialParameter() {
    const { selectedItemId, itemOptionsWithParameter, parameterOptions } =
      this.props;

    if (!selectedItemId) {
      return;
    }
    const foundItem = itemOptionsWithParameter.find(
      (item) => item.option.value.id === selectedItemId
    );
    if (!foundItem) {
      return;
    }
    const foundParameter = parameterOptions.find(
      (parameter) => parameter.value.id === foundItem.parameterId
    );
    this.changeSelectedParameter(foundParameter);
  }

  updateItemOptions = () => {
    const { selectedParameter } = this.state;
    const { itemOptionsWithParameter } = this.props;
    if (!selectedParameter) {
      this.setState({
        itemOptions: itemOptionsWithParameter.map((item) => item.option),
        noItemsForParameter: false,
      });
      return;
    }
    const itemOptions = itemOptionsWithParameter
      .filter((item) => item.parameterId === selectedParameter.value.id)
      .map((item) => item.option);
    const hasItems = itemOptions.length > 0;
    this.setState({
      itemOptions: hasItems ? itemOptions : [this.noItemValue],
      noItemsForParameter: !hasItems,
    });
  };

  changeSelectedParameter = (choice?: IOption<any>) => {
    this.setState(
      {
        selectedParameter: choice,
      },
      this.updateItemOptions
    );
  };

  render() {
    const { parameterOptions, name, disabled } = this.props;
    const { itemOptions, selectedParameter, noItemsForParameter } = this.state;
    return (
      <>
        <Select
          className="flex-1 mr-2"
          value={selectedParameter || this.placeholderValue}
          isClearable={true}
          onChange={this.changeSelectedParameter}
          options={parameterOptions}
          disabled={disabled}
        />
        <FormSelect
          className="flex-1 mr-2"
          name={name}
          options={itemOptions}
          isDisabled={noItemsForParameter || disabled}
        />
      </>
    );
  }
}

export default ItemSelector;



// WEBPACK FOOTER //
// ./src/views/Admin/components/ItemSelector.tsx